import angular from 'angular';
import janglModule from '../jangl'
import jornayaModule from '../jornaya'

import component from './torchmark-form/component.js'
import service from './service';
service.$inject = [ '$http', '$window' ];

var module = angular.module('janglCaptureForms.Torchmark', [janglModule, jornayaModule]);
module.component('torchmarkForm', component);
module.service('janglTorchmarkDataService', service);

export default module.name;


// WEBPACK FOOTER //
// ./app/torchmark/index.js